var exports = {
  "Qs": "x804f0401--af65e8--content",
  "DD": "x804f0401--af65e8--title",
  "z3": "x804f0401--af65e8--error",
  "uW": "x804f0401--af65e8--section",
};

module.exports = exports;
